import React from 'react';
import { oohData } from '../utils/oohData';
import { MicroscopeIcon, GraduationCapIcon } from 'lucide-react';
export const AttentionBlueprint: React.FC = () => {
  const {
    methodology
  } = oohData;
  return <div className="bg-white rounded-xl shadow-sm border-l-4 border-l-[#1E90FF] overflow-hidden" data-id="element-4" data-mp="1jr5y0ekyc7se">
      <div className="p-6 flex flex-col lg:flex-row lg:items-center gap-6" data-id="element-5" data-mp="1oqsc0q8lts29">
        <div className="flex-1" data-id="element-6" data-mp="1tpv65fn1qdvg">
          <div className="flex items-center space-x-2 mb-2" data-id="element-7" data-mp="1tok0tbdycy28">
            <div className="p-1.5 bg-[#1E90FF]/10 text-[#1E90FF] rounded-lg" data-id="element-8" data-mp="1xqyn65gtyfy9">
              <MicroscopeIcon className="w-4 h-4" data-id="element-9" data-mp="1xou94up7w0k9" />
            </div>
            <span className="text-xs font-semibold text-[#1E90FF] uppercase tracking-wider" data-id="element-10" data-mp="22igoiumrmijr">
              Powered by the {methodology.name}
            </span>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed mb-3 max-w-3xl" data-id="element-11" data-mp="2cgw5w5vzqdg2">
            {'Our methodology is built on 17 visual drivers from cognitive psychology that determine what wins those first seconds of attention. Every principle is substantiated with peer-reviewed research.'}
          </p>
          <div className="flex items-center space-x-2 text-xs text-gray-500" data-id="element-12" data-mp="c1p3vjo31788">
            <GraduationCapIcon className="export-icon-down w-4 h-4 flex-shrink-0 text-gray-400" data-id="element-13" data-mp="758giropiww7" />
            <span data-id="element-14" data-mp="33n4t9nwsonl">{methodology.source}</span>
          </div>
        </div>

        {/* Credibility stats */}
        <div className="flex gap-3 lg:flex-col lg:min-w-[190px]" data-id="element-15" data-mp="zrjervouclpu">
          {methodology.stats.map((stat, idx) => <div key={idx} className="flex-1 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3 text-center lg:text-left" data-id="element-16" data-mp="uujg45ubml8r" data-mpi={idx}>
              <p className="text-sm font-semibold text-gray-900 leading-tight" data-id="element-17" data-mp="m0emxfrpsxq2">
                {stat}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
};